import { GzGenericWidgetContent } from '../../../../genericDashboard/gzGenericWidget';
import { html, TemplateResult } from 'lit';
import { property, query, customElement } from 'lit/decorators.js';
import { WidgetStateFrontEnd } from '../../../../genericDashboard/gzGenericWidget/types';
import { styles } from '../view/styles';
import { WEB_COMPONENT_EASM_TOP_VULNERABILITIES } from '../../../../webcomponents.constants';
import { GzEasmGenericTopDataWebComponent } from '../../genericTopData';
import { handleWidgetWithTopDataResize } from '../../../utils/utils';
import { translateFn } from '../../../../utils/translator.helper';
import { MIN_NUMBER_OF_ROWS_TO_DISPLAY } from '../../constants';
import { FilterType } from '../../genericTopData/types/types';
import { FindingClassType } from '../../../types';

@customElement(WEB_COMPONENT_EASM_TOP_VULNERABILITIES)
export class GzEasmCriticalVulnerabilitiesWebComponent extends GzGenericWidgetContent {
  @property({
    type: WidgetStateFrontEnd,
    attribute: true,
    reflect: true,
  })
  state: WidgetStateFrontEnd;

  @property({
    type: Object,
    attribute: true,
    reflect: true,
  })
  payload: any;

  @query('gz-easm-generic-top-data')
  private gzEASMGenericTopData: GzEasmGenericTopDataWebComponent;

  static get styles() {
    return styles;
  }

  protected renderLoader(): TemplateResult {
    return html` <gz-loader rows="1" columns="1" style="margin-top: calc(var(--spacer) * 4)"></gz-loader> `;
  }

  protected renderContent(): TemplateResult {
    const numberOfObjectsDisplayed = this.payload?.criticalVulnerabilities?.rowsData
      ? Object.keys(this.payload?.criticalVulnerabilities?.rowsData).length
      : 0;
    const totalAssets = this.payload?.criticalVulnerabilities?.total;
    const textButton =
      totalAssets > 0
        ? translateFn('View all ({totalAssets})', {
            totalAssets,
          })
        : null;
    return html`
      <gz-easm-generic-top-data
        .rowsData=${this.payload?.criticalVulnerabilities?.rowsData ?? []}
        .buttonText=${textButton}
        .numberOfRowsToDisplay=${numberOfObjectsDisplayed}
        .showSeverity=${true}
        .numberOfRowsAvailable=${numberOfObjectsDisplayed}
        .minNumberOfRowsToDisplay=${MIN_NUMBER_OF_ROWS_TO_DISPLAY}
        .navigateToSmartViewId=${this.payload?.inventorySmartViewId}
        .filterType="${FilterType.CVES}"
        .findingType="${FindingClassType.ARTIFACT}"
      >
      </gz-easm-generic-top-data>
    `;
  }

  protected handleResize(): void {
    super.handleResize();
    handleWidgetWithTopDataResize.call(this);
  }
}
